/**
 * Store Types de missions
 */
export default {
    state: {
        typeMissions: [],
        meuble: 1,
        solaire: 2,
        parahotellerie: 3,
        gestionTva: 4,
        irpp: 5,
        juridique: 6,
        foncier: 7,
        is: 8,
        sciIr: 9,
        hotel: 10,
        bureauEquipe: 11,
        microBic: 12,
    },

    mutations: {
        /**
         * Initialise le state typeMissions
         */
        setTypeMissions: function (state, types) {
            state.typeMissions = types
        }
    },

    getters: {
        /**
         * Liste de tous les types de missions
         */
        optionsTypeMissions: state => {
            return state.typeMissions.map(statut => {
                return {label: statut.nom, value: statut.id}
            })
        },

        optionsTypeMissionsWithoutFoncier: (state, getters) => {
            return getters.optionsTypeMissions.filter(typeMission => typeMission.value !== state.foncier)
        },

        optionsTypeMissionsWithoutMicroBic: (state, getters) => {
            return getters.optionsTypeMissions.filter(typeMission => typeMission.value !== state.microBic)
        },

        optionsTypeMissionsWithoutMicroBicAndFoncier: (state, getters) => {
            return getters.optionsTypeMissions.filter(typeMission => (![state.microBic, state.foncier].includes(typeMission.value)))
        },
    }
}
